import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { CreateCoacheeUiEventCmd } from 'application/ui-statistics/command/create-coachee-ui-event.cmd';
import { ApiAdapter } from 'infrastructure/common/api.adpater';
import { CreateCoacheeUiEventApiMutation } from 'infrastructure/graphql/statistics/ui/mutation/create-coachee-ui-event.api-mutation';
import { UserSessionPort } from 'user/port/user-session.port';

@Injectable({ providedIn: 'root' })
export class UiStatisticsApiMutationHandler extends ApiAdapter {
	constructor(
		userSessionPort: UserSessionPort,
		translateService: TranslateService,
		private _createCoacheeUiEventApiMutation: CreateCoacheeUiEventApiMutation
	) {
		super(userSessionPort, translateService);
	}

	public createCoacheeUiEvent(cmd: CreateCoacheeUiEventCmd): Observable<void> {
		return this.mutate$(this._createCoacheeUiEventApiMutation, cmd);
	}
}
